import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import ButtonLink from '@dashboard/components/mui-atoms/ButtonLink';
import IconButtonLink from '@dashboard/components/mui-atoms/IconButtonLink';
import WpSessionDropdown from '@dashboard/components/SessionDropdown';
import { WhiteWaypointLogo } from '@dashboard/components/WaypointLogo';
import { useCurrentUserQuery, UserRole } from '@dashboard/generated/wp/authentication';
import { DnsOutlined, PeopleOutlined, TimelineOutlined, WorkspacesOutlined } from '@mui/icons-material';
import { AppBar, Box, Container, Divider, Stack, Toolbar } from '@mui/material';

export default function AdministratorPageLayout() {
  const { data } = useCurrentUserQuery();
  const currentUser = data?.currentUser;
  if (!currentUser) {
    return null;
  }
  if (currentUser.role !== UserRole.Admin) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <AppBar color="primary" position="sticky">
        <Container maxWidth="xl">
          <Toolbar
            disableGutters
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Stack spacing={1} direction="row" alignItems="center">
              <WhiteWaypointLogo />
              <Divider flexItem orientation="vertical" />

              <Stack spacing={2} direction="row" alignItems="center" sx={{ display: { xs: 'none', md: 'flex' } }}>
                <ButtonLink href="/admin" size="small" sx={{ color: 'inherit' }}>
                  Platforms
                </ButtonLink>
                <ButtonLink href="/admin/domains" size="small" sx={{ color: 'inherit' }}>
                  Domains
                </ButtonLink>
                <ButtonLink href="/admin/email-messages" size="small" sx={{ color: 'inherit' }}>
                  Activity
                </ButtonLink>
                <ButtonLink href="/admin/users" size="small" sx={{ color: 'inherit' }}>
                  Users
                </ButtonLink>
              </Stack>

              <Stack spacing={1} direction="row" alignItems="center" sx={{ display: { xs: 'flex', md: 'none' } }}>
                <IconButtonLink href="/admin" sx={{ color: 'inherit' }}>
                  <WorkspacesOutlined fontSize="small" />
                </IconButtonLink>
                <IconButtonLink href="/admin/domains" sx={{ color: 'inherit' }}>
                  <DnsOutlined fontSize="small" />
                </IconButtonLink>
                <IconButtonLink href="/admin/email-messages" sx={{ color: 'inherit' }}>
                  <TimelineOutlined fontSize="small" />
                </IconButtonLink>
                <IconButtonLink href="/admin/users" sx={{ color: 'inherit' }}>
                  <PeopleOutlined fontSize="small" />
                </IconButtonLink>
              </Stack>
            </Stack>
            <Box maxWidth={512}>
              <WpSessionDropdown />
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Container maxWidth="xl" sx={{ py: 2 }}>
        <Outlet />
      </Container>
    </>
  );
}
